import { SALESLINE_ADD, SALESORDER_ADD, SALESLINES_CLEAR, SALESORDERS_CLEAR, SALESLINES_GET, SALESLINE_UPDATE, SALESLINE_ADD_QTY, SALESLINE_INDEX, SALESORDER_INDEX, SALESLINE_GET, SALESORDER_SELECT } from '../actions/salesOrder'
import apiCall from '../../utils/api'

const state = {
  orders: [],
  lines: [],
  selected: null
}

const getters = {
  [SALESLINES_GET]: (state, getters) => (ids) => {
    return state.lines.filter(line => ids.includes(line.id))
  },
  [SALESLINE_GET]: (state, getters) => (id) => {
    return state.lines.find(line => id === line.id)
  }
}

const actions = {
  [SALESORDER_INDEX]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/salesOrders', method: 'GET'})
        .then(resp => {
          // commit(SALESLINES_CLEAR)
          // commit(SALESORDERS_CLEAR)
          /* var tmpSalesLines = []
          var tmpSalesOrders = []
          var tmpSalesOrdersCounter = resp.length
          window._.forEach(resp, (salesOrder) => {
            window._.forEach(salesOrder.lines, (salesLine) => {
              tmpSalesLines = [...tmpSalesLines, salesLine]
              // commit(SALESLINE_ADD, salesLine)
            })
            salesOrder.lines = window._.map(salesOrder.lines, 'id')
            tmpSalesOrders = [...tmpSalesOrders, salesOrder]
            if (--tmpSalesOrdersCounter === 0) {
              commit(SALESLINE_INDEX, tmpSalesLines)
              commit(SALESORDER_INDEX, tmpSalesOrders)
            }
            // commit(SALESORDER_ADD, salesOrder)
          }) */
          commit(SALESORDER_INDEX, resp)
          resolve()
        })
    })
  }
}

const mutations = {
  [SALESLINE_INDEX]: (state, resp) => {
    state.lines = resp
  },
  [SALESORDER_INDEX]: (state, resp) => {
    state.orders = resp
  },
  [SALESORDER_SELECT]: (state, resp) => {
    state.selected = state.orders.find(order => { return order.id === resp })
  },
  [SALESLINE_ADD]: (state, resp) => {
    state.lines = [...state.lines, resp]
  },
  [SALESORDER_ADD]: (state, resp) => {
    state.orders = [...state.orders, resp]
  },
  [SALESLINES_CLEAR]: (state) => {
    state.lines = []
  },
  [SALESORDERS_CLEAR]: (state) => {
    state.orders = []
  },
  [SALESLINE_UPDATE]: (state, salesLine) => {
    state.lines = [
      ...state.line.filter(line => line.id !== salesLine),
      salesLine
    ]
  },
  [SALESLINE_ADD_QTY]: (state, {salesLine, data}) => {
    salesLine.qty_done += parseFloat(data.qty)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/salesOrder.js